import { SxProps, Theme } from '@mui/material';

/** Left-aligned expand chevron for preview pane section accordions. */
export const previewAccordionSummarySx: SxProps<Theme> = {
  flexDirection: 'row-reverse',
  px: 0,
  minHeight: 40,
  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'none',
    mr: 0.5,
    ml: 0,
  },
  '&.Mui-expanded .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(180deg)',
  },
  '& .MuiAccordionSummary-content': {
    margin: '8px 0',
    alignItems: 'center',
  },
};
